import React, { useState } from "react";

interface Props {}
const AKCContainer: React.FC<Props> = ({}) => {
  return (
    <div className="akc-authorized template">
      <article className="template-circle-header akc-authorized__header ">
        <div className="template-circle-header__content">
          <div className="template-circle-header__content-copy">
            <h1 className="template-element-title--header ">AKC Reunite</h1>
            <h2 className="template-circle-header__subtitle">
              PuppySpot is dedicated to promoting the health and well-being of
              all dogs.
            </h2>
            <p>
              <span lang="EN-US" data-contrast="auto">
                PuppySpot is dedicated to promoting the health and well-being of
                all dogs.&nbsp; We have a long-standing relationship with the
                American Kennel Club (AKC), allowing our customers the unique
                opportunity to take advantage of their sought after Registration
                and Reunite programs.&nbsp; Through PuppySpot, you can purchase
                AKC Registration which comes with a certificate and variety of
                perks.&nbsp; Also available is the AKC Reunite program – we
                highly encourage all puppy owners to enroll their pup in AKC
                Reunite—a national lost dog recovery service through The
                American Kennel Club—to help them make it home safely if they
                ever go missing. As an added safety measure, a set of two
                engraved pet tags, for both owner and puppy identification, are
                included in your purchase.
              </span>
              <span data-ccp-props='{"201341983":0,"335559739":0,"335559740":240}'>
                &nbsp;
              </span>
            </p>
          </div>
          <picture className="">
            <img
              id=""
              alt=""
              className="template-circle-header__image lazyloaded"
              data-cy=""
              data-src="https://cdn.buttercms.com/YKYmF4VdS9GTjUiclHfA"
              loading="lazy"
              src="https://cdn.buttercms.com/YKYmF4VdS9GTjUiclHfA"
            />
          </picture>
        </div>
      </article>
      <section className="akc-authorized__benefits">
        <div>
          <h2>How You Benefit</h2>
        </div>
        <article className="template-icon-grid template-icon-grid--akc-authorized akc-authorized__benefits-grid">
          <div className="template-icon-grid__card">
            <picture className="">
              <img
                id=""
                alt=""
                className=" lazyloaded"
                data-cy=""
                data-src="https://cdn.buttercms.com/fDlIc03tQpOVzefEYkjA"
                loading="lazy"
                src="https://cdn.buttercms.com/fDlIc03tQpOVzefEYkjA"
              />
            </picture>

            <div className="template-icon-grid__card-copy">
              <h3 id="template-icon-grid__akc-benefits-akc-reunite">
                AKC Registration
              </h3>
              <div
                role="definition"
                aria-labelledby="template-icon-grid__akc-benefits-akc-reunite"
              >
                <p>
                  <span lang="EN-US" data-contrast="auto">
                    {" "}
                  </span>
                  <span lang="EN-US" data-contrast="auto">
                    Every PuppySpot puppy is eligible for AKC Registration
                    complete with official ownership documentation and a
                    registration certificate.&nbsp; Also included is an
                    e-subscription full of education snips, training tips - AKC
                    GoodDog Helpline, and entertaining canine stories.&nbsp;
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="template-icon-grid__card">
            <picture className="">
              <img
                id=""
                alt=""
                className=" lazyloaded"
                data-cy=""
                data-src="https://cdn.buttercms.com/dqMk0nUS5GI8PKJjpd0t"
                loading="lazy"
                src="https://cdn.buttercms.com/dqMk0nUS5GI8PKJjpd0t"
              />
            </picture>

            <div className="template-icon-grid__card-copy">
              <h3 id="template-icon-grid__akc-benefits-e-subscription">
                AKC Reunite
              </h3>
              <div
                role="definition"
                aria-labelledby="template-icon-grid__akc-benefits-e-subscription"
              >
                <p>
                  <span lang="EN-US" data-contrast="auto">
                    Lifetime enrollment in AKC’s national lost dog recovery
                    service.&nbsp; Through this service you can register your
                    puppy’s microchip in the event your puppy is ever lost or
                    stolen.&nbsp; This information will help aid the safe return
                    of your puppy with the help of AKC’s Lost Pet Alert.&nbsp;
                  </span>
                  <span data-ccp-props='{"201341983":0,"335559739":0,"335559740":240}'>
                    &nbsp;
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="template-icon-grid__blurb"></div>
        </article>
        <div className="akc-authorized__tagline">
          <picture className="">
            <img
              id=""
              alt=""
              className=" lazyloaded"
              data-cy=""
              data-src="https://cdn.buttercms.com/UeAsTPOTQy2aEAUzTEaw"
              loading="lazy"
              src="https://cdn.buttercms.com/UeAsTPOTQy2aEAUzTEaw"
            />
          </picture>

          <span>An offer just for PuppySpot parents</span>
        </div>
        <p className="akc-authorized__benefits-blurb">
          Each PuppySpot puppy is eligible for American Kennel Club (AKC)
          Registration and AKC Reunite which will be facilitated by AKC after
          purchase. By purchasing, you and your puppy will reap benefits of AKC
          programs offered to only select puppies around the nation.
        </p>
        <article className="akc-article template-icon-grid template-icon-grid--akc-authorized akc-authorized__benefits-grid">
          <div className="template-icon-grid__card">
            <picture className="">
              <img
                id=""
                alt=""
                className=" lazyloaded"
                data-cy=""
                data-src="https://cdn.buttercms.com/2eRIsB0IR9OgvvBqbs2i"
                loading="lazy"
                src="https://cdn.buttercms.com/2eRIsB0IR9OgvvBqbs2i"
              />
            </picture>

            <div className="template-icon-grid__card-copy">
              <h3 id="template-icon-grid__akc-benefits-akc">
                Microchip Enablement
              </h3>
              <div
                role="definition"
                aria-labelledby="template-icon-grid__akc-benefits-akc"
              >
                <p>
                  The ability to have your puppy's microchip enabled, for both
                  owner and puppy identification, are included in your AKC
                  purchase.
                </p>
              </div>
            </div>
          </div>
          <div className="template-icon-grid__card">
            <picture className="">
              <img
                id=""
                alt=""
                className=" lazyloaded"
                data-cy=""
                data-src="https://cdn.buttercms.com/jA1ow86eR7iyVcb5iBKe"
                loading="lazy"
                src="https://cdn.buttercms.com/jA1ow86eR7iyVcb5iBKe"
              />
            </picture>

            <div className="template-icon-grid__card-copy">
              <h3 id="template-icon-grid__akc-benefits-lifetime-access">
                Lifetime Event Eligibility &amp; E-subscription
              </h3>
              <div
                role="definition"
                aria-labelledby="template-icon-grid__akc-benefits-lifetime-access"
              >
                <p>
                  <span lang="EN-US" data-contrast="auto">
                    Lifetime access to all AKC events including dog shows,
                    trials, and field events.&nbsp;
                  </span>
                  <span data-ccp-props='{"201341983":0,"335559739":0,"335559740":240}'>
                    &nbsp;
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="template-icon-grid__blurb"></div>
        </article>
      </section>
      <article
        className="template-image-copy image-left overlapped akc-authorized__building-trust"
        id="building-trust"
      >
        <div className="template-image-copy__content">
          <div
            style={{
              backgroundImage:
                "url('https://cdn.buttercms.com/L4axTicjQRW4k0sU8Dgi')",
            }}
            className="template-image-copy__image akc-authorized__building-trust-image"
          ></div>
          <div className="template-image-copy__copy akc-authorized__building-trust-copy">
            <h2 className="template-element-title ">
              Building Trust Between Owners and Breeders
            </h2>
            <ul className="template-list">
              <li className="green-check template-copy">
                PuppySpot offers you the comfort of knowing:
              </li>
              <li className="green-check template-copy">
                PuppySpot proudly promotes breeder education, health testing and
                continued industry enhancements.
              </li>
              <li className="green-check template-copy">
                PuppySpot is regularly inspected by the USDA and ensures that
                every breeder in our community is held to our industry leading
                standards.
              </li>
              <li className="green-check template-copy">
                PuppySpot and the breeders we work with are all licensed or
                exempt from licensing.
              </li>
              <li className="green-check template-copy">
                We provide new owner support through every step of the process,
                even after your puppy arrives home.
              </li>
              <li className="green-check template-copy">
                We have been in business for nearly 20 years and have found
                happy homes for over 220,000 healthy puppies.
              </li>
            </ul>
          </div>
        </div>
      </article>
      <div className="cta-white mb30 mt30">
        <a href="/puppies-for-sale">
          Let's find you a puppy!
        </a>
      </div>
    </div>
  );
};

export default AKCContainer;
